import {item} from './itemOld';

export const query = `query getRelatedItemsOld($externalId: String!, $productIds: [String!]!, $withOptions: Boolean = false, $withPriceRange: Boolean = false) {
    appSettings(externalId: $externalId) {
      widgetSettings
    }
    catalog {
      relatedProducts(productIds: $productIds) {
         ${item}
      }
    }
  }
  `;
